<template>
  <div class="app">
    <router-view />
    <div
      class="flex w-full h-full items-center justify-center"
      v-if="!authStore.authVariablesSet && !router.currentRoute.value.meta.noLoader"
    >
      <div class="loader"></div>
    </div>
    <Toast ref="toast" />
  </div>
</template>

<script setup>
import 'vue-skeletor/dist/vue-skeletor.css';
import 'primeicons/primeicons.css';
import { ref, onMounted } from 'vue';
import { useDonorStore } from '@/stores/DonorStore.js';
import { useAuthStore } from '@/stores/AuthStore.js';
import { useRouter } from 'vue-router';
import { useToastStore } from '@/stores/ToastStore.js';

const router = useRouter();

const donorStore = useDonorStore();
const authStore = useAuthStore();

const toast = ref(null);

onMounted(() => {
  useToastStore().toastRef = toast.value;
});
</script>

<style>
titan-button {
  --btn-secondary-solid-bg: var(--p-primary-500);
  --btn-secondary-solid-border: var(--p-primary-500);
  --btn-secondary-solid-hover-bg: var(--p-primary-500);
  --btn-secondary-solid-hover-border: var(--p-primary-500);
  --btn-primary-outline-border: var(--p-primary-500);
  --btn-primary-outline-hover-border: var(--p-primary-500);
  --btn-primary-solid-bg: var(--p-primary-500);
  --btn-primary-solid-border: var(--p-primary-500);
  --btn-primary-solid-hover-bg: var(--p-primary-500);
  --btn-primary-solid-hover-border: var(--p-primary-500);
}

titan-text-input {
  --form-border-color-default: var(--p-primary-500);
  --dropdown-item-color: #000;
  --dropdown-item-font: Poppins, sans-serif;
  --text-input-font: Poppins, sans-serif;
}
titan-dropdown {
  --form-border-color-default: var(--p-primary-500);
  --dropdown-item-font: Poppins, sans-serif;
  --dropdown-item-color: #000;
  --dropdown-input-font: Poppins, sans-serif;
}

titan-multiselect {
  --text-filter-trigger-color: #000;
  --text-filter-name-color: #000;
  --multiselect-text-font: Poppins, sans-serif;
  --multiselect-option-text-font: Poppins, sans-serif;
  --text-options-color: #000;
}

titan-text-area {
  --text-area-font: Poppins, sans-serif;
}
.app {
  font-family: Poppins, sans-serif;
}
.poppins {
  font-family: Poppins, sans-serif;
}
.font-24 {
  font-size: 1.5rem;
}
.font-12 {
  font-size: 0.75rem;
}
.font-13 {
  font-size: 0.813rem;
}
.font-14 {
  font-size: 0.875rem;
}
.font-16 {
  font-size: 1rem;
}
.font-20 {
  font-size: 1.25rem;
}
.font-22 {
  font-size: 1.375rem;
}
.weight-400 {
  font-weight: 400;
}
.weight-500 {
  font-weight: 500;
}
.weight-600 {
  font-weight: 600;
}
.weight-700 {
  font-weight: 700;
}
.weight-900 {
  font-weight: 900;
}
.header {
  font-size: 2.25rem;
  font-weight: 600;
  margin-bottom: 20px;
}
.page {
  display: flex;
  flex-direction: column;
  padding: 40px 40px 88px;
  min-height: calc(100vh - 108px);
}

.centered-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
}

.content-box {
  font-size: 1rem;
  margin: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.paragraph {
  margin-bottom: 20px;
  font-size: 16px;
  text-align: center;
  word-wrap: break-word;
}

.blank-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
@media screen and (max-width: 1024px) {
  .header {
    justify-content: center;
  }
  .page {
    padding: 48px 0 48px 0;
    align-items: center;
  }
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 12px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #000;
  clip-path: inset(-220%);
  animation: l28 2s infinite linear;
}
@keyframes l28 {
  0% {
    box-shadow: 0 0 0 0, 40px 0, -40px 0, 0 40px, 0 -40px;
  }
  10% {
    box-shadow: 0 0 0 0, 12px 0, -40px 0, 0 40px, 0 -40px;
  }
  20% {
    box-shadow: 0 0 0 4px, 0px 0, -40px 0, 0 40px, 0 -40px;
  }
  30% {
    box-shadow: 0 0 0 4px, 0px 0, -12px 0, 0 40px, 0 -40px;
  }
  40% {
    box-shadow: 0 0 0 8px, 0px 0, 0px 0, 0 40px, 0 -40px;
  }
  50% {
    box-shadow: 0 0 0 8px, 0px 0, 0px 0, 0 12px, 0 -40px;
  }
  60% {
    box-shadow: 0 0 0 12px, 0px 0, 0px 0, 0 0px, 0 -40px;
  }
  70% {
    box-shadow: 0 0 0 12px, 0px 0, 0px 0, 0 0px, 0 -12px;
  }
  80% {
    box-shadow: 0 0 0 16px, 0px 0, 0px 0, 0 0px, 0 0px;
  }
  90%,
  100% {
    box-shadow: 0 0 0 0, 40px 0, -40px 0, 0 40px, 0 -40px;
  }
}
</style>
